import { registerRoot } from "remotion";
// import TikTokVideo from "./TikTokVideo";
import TikTokVideoVanilla from "./TikTokVideoVanilla";
import { SocialCompositions } from "../socialreel/compositions";
import { CityGuideComposition } from "./cityguide/CityGuide";
import { FeatureIntroCompositions } from "../featureintro/compositions";

/**
 * This bundle is what the render worker serves, so every composition it must reach has to be
 * registered here. The social compositions were previously added to ./RemotionRoot.tsx — a file
 * nothing imports — so the bundle published fine and the worker still reported
 * "Available compositions: reel".
 */
const Root: React.FC = () => (
	<>
		<TikTokVideoVanilla />
		<SocialCompositions />
		<CityGuideComposition />
		<FeatureIntroCompositions />
	</>
);

registerRoot(Root);
